import { render } from "./S80861.vue?vue&type=template&id=120ed1eb"
const script = {}
script.render = render

export default script